import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/style/index.css";
import VueI18n from "./i18n";

const app = createApp(App);
// 引入组件 注册组件
import Component from "@/components";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

for (const componentKey in Component) {
  app.component(Component[componentKey].name, Component[componentKey]);
}
import "element-plus/lib/components/image/style/css";
import "element-plus/lib/components/dialog/style/css";
import "element-plus/lib/components/link/style/css";
import "element-plus/lib/components/dropdown/style/css";

app.use(VueI18n);
app.use(store).use(router).mount("#app");
